import {
  fetchDataWithLoadMore,
  addDocToCollection,
  fetchDocumentById,
} from "./helperAction";
import firebase from "config/firebase";
import { toast } from "react-toastify";

const db = firebase.firestore();

export const fetchSchoolContests = ({
  athleteId,
  schoolId,
  status,
  sport,
  lastVisible = null,
}) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        let queryOptions = [
          { method: "orderBy", args: ["createdAt", "desc"] },
          { method: "where", args: ["schoolId", "==", schoolId] },
          { method: "where", args: ["status", "in", status] },
          { method: "where", args: ["sportName", "==", sport] },
        ];

        const response = await fetchDataWithLoadMore({
          collectionName: "contest_schools",
          queryOptions,
          lastVisible,
        });

        const updatedContests = await Promise.all(
          response?.data?.map(async (contest) => {
            const contestSchoolDoc = await db
              .collection("contest")
              .doc(contest?.contestId)
              .get();

            if (!contestSchoolDoc?.exists) {
              return null;
            }
            const athleteDoc = await db
              .collection("contest_athletes")
              .where("contestId", "==", contest?.contestId)
              .where("athleteId", "==", athleteId)
              .get();

            if (!status.includes("accepted") && athleteDoc.empty) {
              return null;
            }
            const participated = athleteDoc.empty ? "pending" : "participated";

            return {
              id: contestSchoolDoc.id,
              participated: participated,
              ...contestSchoolDoc.data(),
            };
          })
        );

        const filteredContests = updatedContests.filter(
          (contest) => contest !== null
        );

        dispatch({
          type: "FETCH_CONTESTS_SUCCESS",
          payload: {
            ...response,
            data: filteredContests,
          },
        });

        resolve({ data: filteredContests, ...response });
      } catch (error) {
        toast.error(error.message || "Unable to fetch organizers");
        reject(error);
      }
    });
  };
};

export const participateContest = ({ payload, onSuccess = () => {} }) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await dispatch(
          addDocToCollection({
            collectionName: "contest_athletes",
            payload,
          })
        );

        toast.success("Participated in contest successfully!");
        dispatch({
          type: "PARTICIPATE_CONTEST_SUCCESS",
          payload: payload?.contestId,
        });

        await firebase.firestore().collection("fan_notifications").add({
          athleteId: payload.athleteId,
          createdAt: firebase.firestore.Timestamp.now(),
          isRead: [],
          type: "talent_contest",
        });

        onSuccess();
        resolve(response);
      } catch (error) {
        toast.error(error.message || "Unable to add contest");
        reject(error);
      }
    });
  };
};

export const fetchContestOrganizer = ({ contestId }) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        const contest = await fetchDocumentById({
          collectionName: "contest",
          docId: contestId,
        });

        const organizer = await fetchDocumentById({
          collectionName: "users",
          docId: contest?.userId,
        });

        dispatch({
          type: "FETCH_CONTESTS_ORGANIZER_SUCCESS",
          payload: organizer,
        });
        resolve(organizer);
      } catch (error) {
        toast.error(error.message || "Unable to fetch contest organizer");
        reject(error);
      }
    });
  };
};

export const fetchContestDetails = ({
  collectionName,
  contestId,
  contestKey = "contestId",
  userKey = "userId",
  lastVisible = null,
}) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        const queryOptions = [
          { method: "orderBy", args: ["createdAt", "desc"] },
          { method: "where", args: [contestKey, "==", contestId] },
        ];

        let response = await fetchDataWithLoadMore({
          collectionName,
          queryOptions,
          lastVisible,
        });

        const updatedData = await Promise.all(
          response.data.map(async (item) => {
            if (!item[userKey]) return item;
            const userDoc = await fetchDocumentById({
              collectionName: "users",
              docId: item[userKey],
            });
            return {
              ...item,
              userData: userDoc,
            };
          })
        );

        response = { ...response, data: updatedData };
        dispatch({
          type: "FETCH_CONTESTS_DETAILS_SUCCESS",
          payload: response,
        });
        resolve(response);
      } catch (error) {
        toast.error(error.message || "Unable to fetch contest details");
        reject(error);
      }
    });
  };
};
